interface TypingAnimationProps {
  className?: string;
}

export function TypingAnimation({ className = "" }: TypingAnimationProps) {
  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      <style>{`
        @keyframes typing-dot {
          0%, 60%, 100% {
            transform: translateY(0);
            opacity: 0.4;
          }
          30% {
            transform: translateY(-10px);
            opacity: 1;
          }
        }
        .typing-dot {
          animation: typing-dot 1.4s ease-in-out infinite;
        }
        .typing-dot:nth-child(1) {
          animation-delay: 0ms;
        }
        .typing-dot:nth-child(2) {
          animation-delay: 200ms;
        }
        .typing-dot:nth-child(3) {
          animation-delay: 400ms;
        }
      `}</style>
      <div className="flex space-x-1 items-center">
        <div className="w-2 h-2 bg-brand-muted rounded-full typing-dot"></div>
        <div className="w-2 h-2 bg-brand-muted rounded-full typing-dot"></div>
        <div className="w-2 h-2 bg-brand-muted rounded-full typing-dot"></div>
      </div>
    </div>
  );
}
